import { render, staticRenderFns } from "./ddx.vue?vue&type=template&id=aaebc3ca"
import script from "./ddx.vue?vue&type=script&lang=js"
export * from "./ddx.vue?vue&type=script&lang=js"
import style0 from "./ddx.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports